import axios from 'axios';

export const HANDLE_PAGE = 'MAIN_PAGE/HANDLE_PAGE';
export const GET_VERSION_FETCH = 'MAIN_PAGE/GET_VERSION_FETCH';
export const GET_VERSION_SUCCESS = 'MAIN_PAGE/GET_VERSION_FETCH';
export const GET_VERSION_ERROR = 'MAIN_PAGE/GET_VERSION_ERROR';

export const handlePage = (page) => ({
  type: HANDLE_PAGE,
  page,
});

export const getVersion = () => (dispatch) => {
  const baseUrl = 'api/get-version';
  dispatch({ type: GET_VERSION_FETCH });
  axios.get(baseUrl).then((response) => {
    const { version } = response.data;
    dispatch({ type: GET_VERSION_SUCCESS, version });
  }).catch((error) => {
    dispatch({ type: GET_VERSION_ERROR });
  });
};
